"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NoOpEventDispatcher {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attachContext(key, value) {
        // Do nothing
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatch(_) {
        // Do nothing
    }
}
exports.default = NoOpEventDispatcher;
//# sourceMappingURL=no-op-event-dispatcher.js.map